import makeRequestHeaders from '@src/utils/make-request-headers';

const getConsultAppointments = async ({
	leadId,
	salesforceId,
	centerId,
	startDate,
	signal,
	answers,
	enableHydra = false,
	sessionId = 'N/A',
}: {
	leadId: string;
	salesforceId?: string;
	centerId: string;
	startDate: string;
	signal: AbortSignal;
	answers: object;
	enableHydra?: boolean;
	sessionId: string | undefined;
}) => {
	try {
		const queryString = `?lead_id=${leadId}&center_id=${centerId}&start_date=${startDate}&sf_id=${
			salesforceId ?? ''
		}&answers=${JSON.stringify(answers)}`;
		const response = await fetch(process.env.APP_PATH + '/api/clear-choice/get-appointments/' + queryString, {
			headers: makeRequestHeaders({ sessionId, enableHydraCalls: enableHydra }),
			method: 'GET',
			signal,
		});

		const result = await response.json();
		return result;
	} catch (error) {
		if (signal.aborted) {
			console.log('Fetch request aborted');
		} else if (error instanceof Error) {
			console.error(`Failed Loading Consults Appointments Data: ${error.message}`);
		}
		return [];
	}
};

export { getConsultAppointments };
